import {
	RENAME_CREATIVE,
	DOWNLOAD_CREATIVE_SUMMARY,
	DELETE_CREATIVE
} from "./EllipsisActions";

export const CTV_ELLIPSIS_ACTION_LIST = [
	[
		RENAME_CREATIVE,
		DOWNLOAD_CREATIVE_SUMMARY,
	],
	[
		DELETE_CREATIVE,
	],
];
